module.exports = __webpack_public_path__ + "static/media/CloseCircleItem.1f7c3663.svg";